import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Solicitudes.css";
import Logo from "../assets/N_Logo_White.png";
import { toast } from "react-toastify";
import { FiLoader, FiLogOut } from "react-icons/fi";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_CREDITS;

const portalApi =
  axios.create({
    baseURL: API
  });

const getPortalToken = () =>
  localStorage.getItem(
    "creditPortalToken"
  );

export default function Solicitudes() {

  let afiliadoGuardado = null;

  try {

    const saved =
      localStorage.getItem("afiliado");

    if (
      saved &&
      saved !== "undefined"
    ) {
      afiliadoGuardado =
        JSON.parse(saved);
    }

  } catch (error) {

    console.error(
      "Error leyendo afiliado",
      error
    );

    localStorage.removeItem(
      "afiliado"
    );

  }

  const portalTokenGuardado =
    getPortalToken();

  const [logged, setLogged] =
    useState(
      Boolean(
        afiliadoGuardado &&
        portalTokenGuardado
      )
    );

  const [user, setUser] =
    useState(
      portalTokenGuardado
        ? afiliadoGuardado
        : null
    );


  const [
    identificacion,
    setIdentificacion
  ] = useState(
    portalTokenGuardado
      ? afiliadoGuardado
        ?.identificacion || ""
      : ""
  );

  const [celular, setCelular] = useState("");
  const [quotas, setQuotas] = useState([]);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [selectedQuota, setSelectedQuota] = useState(null);
  const [requestValue, setRequestValue] = useState("");
  const [requestObs, setRequestObs] = useState("");
  const [sendingRequest, setSendingRequest] = useState(false);
  const [requestPlazo, setRequestPlazo] = useState("");
  const [showAllHistory, setShowAllHistory] = useState(false);
  const [loadingPortalData, setLoadingPortalData] = useState(false);
  const sessionTimer = useRef(null);

  const login = async () => {
    try {
      setLoading(true);

      const { data } =
        await portalApi.post(
          "/public/login",
          {
            identificacion,
            celular
          }
        );

      if (
        !data?.afiliado ||
        !data?.token
      ) {
        throw new Error(
          "El servidor no devolvió una sesión válida."
        );
      }

      localStorage.setItem(
        "afiliado",
        JSON.stringify(
          data.afiliado
        )
      );

      localStorage.setItem(
        "creditPortalToken",
        data.token
      );

      setUser(
        data.afiliado
      );

      setIdentificacion(
        data.afiliado
          .identificacion
      );

      setLogged(true);

      setTimeout(() => {
        loadPortalData(
          data.afiliado.identificacion,
          data.token
        );
      }, 100);

    } catch (error) {
      console.error(
        "Error ingresando al portal:",
        error
      );

      toast.error(
        error?.response?.data
          ?.message ||
        error.message ||
        "No fue posible ingresar"
      );
    } finally {
      setLoading(false);
    }
  };

  const loadPortalData = async (
    id,
    receivedToken = null
  ) => {
    try {

      setLoadingPortalData(true);

      const portalToken =
        receivedToken ||
        getPortalToken();

      if (!portalToken) {
        logout();
        return;
      }

      const config = {
        headers: {
          Authorization:
            `Bearer ${portalToken}`
        }
      };

      const [
        quotasResponse,
        historyResponse
      ] = await Promise.all([
        portalApi.get(
          `/public/quotas/${id}`,
          config
        ),

        portalApi.get(
          `/public/history/${id}`,
          config
        )
      ]);

      setQuotas(
        quotasResponse.data
      );

      setHistory(
        historyResponse.data
      );
    } catch (error) {
      console.error(
        "Error cargando portal:",
        error
      );

      if (
        error.response?.status ===
        401
      ) {

        localStorage.removeItem(
          "afiliado"
        );

        localStorage.removeItem(
          "creditPortalToken"
        );

        setLogged(false);
        setUser(null);
        setQuotas([]);
        setHistory([]);
        setIdentificacion("");
        setCelular("");
        setSelectedQuota(null);
        setShowRequestModal(false);

        toast.info(
          "La sesión del portal venció. Ingresa nuevamente."
        );

        return;
      }

      toast.error(
        error.response?.data
          ?.message ||
        "No fue posible cargar la información."
      );
    }

    finally {
      setLoadingPortalData(false);
    }
  };

  useEffect(() => {
    let savedAffiliate = null;

    try {
      const saved =
        localStorage.getItem(
          "afiliado"
        );

      if (
        saved &&
        saved !== "undefined"
      ) {
        savedAffiliate =
          JSON.parse(saved);
      }
    } catch (error) {
      console.error(
        "Error leyendo sesión del portal:",
        error
      );

      localStorage.removeItem(
        "afiliado"
      );

      localStorage.removeItem(
        "creditPortalToken"
      );

      return;
    }

    const portalToken =
      getPortalToken();

    if (
      !savedAffiliate
        ?.identificacion ||
      !portalToken
    ) {
      localStorage.removeItem(
        "afiliado"
      );

      localStorage.removeItem(
        "creditPortalToken"
      );

      setLogged(false);
      setUser(null);

      return;
    }

    setLogged(true);

    setUser(
      savedAffiliate
    );

    setIdentificacion(
      savedAffiliate
        .identificacion
    );

    loadPortalData(
      savedAffiliate
        .identificacion,
      portalToken
    );
  }, []);

  useEffect(() => {

    if (!logged) return;

    const resetTimer = () => {

      clearTimeout(
        sessionTimer.current
      );

      sessionTimer.current =
        setTimeout(() => {

          autoLogout();

        }, 5 * 60 * 1000);

    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart"
    ];

    events.forEach(event => {

      window.addEventListener(
        event,
        resetTimer
      );

    });

    resetTimer();

    return () => {

      events.forEach(event => {

        window.removeEventListener(
          event,
          resetTimer
        );

      });

      clearTimeout(
        sessionTimer.current
      );

    };

  }, [logged]);

  const solicitar = (quota) => {
    setSelectedQuota(quota);
    setRequestValue("");
    setRequestObs("");

    if (getPlazo(quota) === 1) {
      setRequestPlazo("1");
    } else {
      setRequestPlazo("");
    }

    setShowRequestModal(true);
  };

  const enviarSolicitud =
    async () => {
      if (sendingRequest) {
        return;
      }

      const requestedValue =
        Number(requestValue);

      const requestedTerm =
        Number(requestPlazo);

      if (!requestPlazo) {
        toast.warning(
          "Seleccione el plazo"
        );
        return;
      }

      if (!requestValue) {
        toast.warning(
          "Ingrese el valor"
        );
        return;
      }

      if (
        requestedValue < 50000
      ) {
        toast.warning(
          "El valor mínimo solicitado debe ser de $50.000"
        );
        return;
      }

      if (
        requestedValue >
        Number(
          selectedQuota.disponible ||
          0
        )
      ) {
        toast.warning(
          "El valor solicitado supera el cupo disponible."
        );
        return;
      }

      try {
        setSendingRequest(true);

        const portalToken =
          getPortalToken();

        await portalApi.post(
          "/request",
          {
            lineaCredito:
              selectedQuota
                .lineaCredito,

            valorSolicitado:
              requestedValue,

            plazoMeses:
              requestedTerm,

            observaciones:
              requestObs
          },
          {
            headers: {
              Authorization:
                `Bearer ${portalToken}`
            }
          }
        );

        toast.success(
          "Solicitud enviada correctamente"
        );

        setShowRequestModal(false);
        setSelectedQuota(null);
        setRequestValue("");
        setRequestPlazo("");
        setRequestObs("");

        await loadPortalData(
          identificacion
        );
      } catch (error) {
        toast.error(
          error?.response?.data
            ?.message ||
          "No fue posible enviar la solicitud"
        );
      } finally {
        setSendingRequest(false);
      }
    };

  const getPlazo = (
    quota
  ) =>
    Number(
      quota?.paymentTerm || 0
    );

  const logout = () => {
    localStorage.removeItem(
      "afiliado"
    );

    localStorage.removeItem(
      "creditPortalToken"
    );

    clearTimeout(
      sessionTimer.current
    );

    setLogged(false);
    setUser(null);
    setQuotas([]);
    setHistory([]);
    setIdentificacion("");
    setCelular("");
    setSelectedQuota(null);
    setShowRequestModal(false);
  };

  const autoLogout = () => {

    if (!localStorage.getItem("afiliado")) {
      return;
    }

    logout();

    toast.info(
      "Sesión cerrada por inactividad"
    );

  };

  const getPrimerNombre = (
    nombreCompleto
  ) => {
    if (!nombreCompleto) {
      return "";
    }

    const partes =
      String(nombreCompleto)
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean);

    let primerNombre = "";

    if (partes.length >= 3) {
      primerNombre =
        partes[2];
    } else if (
      partes.length === 2
    ) {
      primerNombre =
        partes[1];
    } else {
      primerNombre =
        partes[0] || "";
    }

    return (
      primerNombre
        .charAt(0)
        .toUpperCase() +
      primerNombre.slice(1)
    );
  };

  const getSaludo = () => {
    const hora = new Date().getHours();

    if (hora >= 6 && hora < 12) return "Buenos días";
    if (hora >= 12 && hora < 18) return "Buenas tardes";
    return "Buenas noches";
  };

  const visibleHistory =
    showAllHistory
      ? history
      : history.slice(0, 2);

  if (!logged) {

    return (

      <>

      <PageTitle title="Login Créditos" />

      <div className="sol-page">

        <div className="sol-container-login">

          <div className="sol-header-login">

            <img
              src={Logo}
              alt="Logo"
              className="sol-logo"
            />

            <hr className="sol-divider" />

            <h1>
              Solicitud de Crédito
            </h1>

            <p>
              ¡Consulta tus cupos disponibles y realiza solicitudes de crédito!
            </p>

          </div>

          <div className="sol-card">

            <input
              type="number"
              placeholder="Número de identificación"
              value={identificacion}
              onChange={(e) =>
                setIdentificacion(
                  e.target.value
                )
              }
            />

            <input
              type="tel"
              maxLength={10}
              placeholder="Número de celular registrado"
              value={celular}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // solo números
                if (value.length <= 10) {
                  setCelular(value);
                }
              }}
            />

            <button
              className="sol-btn-login"
              onClick={login}
              disabled={loading}
            >

              {loading ? (
                <>
                  <FiLoader className="spin" />
                  Ingresando...
                </>
              ) : (
                "Ingresar"
              )}

            </button>

          </div>

          <div className="sol-footer">

            © {new Date().getFullYear()}
            {" "}
            Gestión360°

          </div>

        </div>

      </div>

      </>

    );

  }

  return (

    <>

    <PageTitle title="Solicitudes" />

    <div className="sol-root">

      <div className="sol-header">

        <h1>
          <span className="saludo-nombre">
            ¡{getSaludo()},
          </span>

          {" "}

          <span className="saludo-texto">

            {getPrimerNombre(user?.nombre)}

          </span>

          <span className="saludo-nombre">
            !
          </span>
        </h1>


        <div className="sol-text">

          Gestiona tus créditos en un solo lugar. 
          Consulta tus cupos disponibles, solicita 
          nuevos créditos y haz seguimiento al estado 
          de cada solicitud.

        </div>

        <hr className="sol-divider" />

        <button
          className="sol-btn-logout"
          onClick={logout}
        >
          <FiLogOut className="icon" /> Cerrar sesión
        </button>

      </div>

      <hr className="sol-divider-II" />

      <h3>
        Créditos disponibles
      </h3>

      {loadingPortalData && (
        <div className="sol-loading">
          <FiLoader className="spin" />
          Consultando cupos disponibles...
        </div>
      )}


      <p className="sol-history-text">
        {loadingPortalData
          ? "Estamos consultando tus cupos disponibles."
          : quotas.length > 0
            ? "Explora las líneas de crédito disponibles y elige la opción ideal para cumplir tus metas."
            : ""}
      </p>

      {!loadingPortalData &&
        quotas.length === 0 && (
          <div className="sol-empty-quotas">
            <strong>
              Sin cupos disponibles
            </strong>

            <span>
              Puede ocurrir porque
              el cupo calculado es inferior al
              valor mínimo permitido.
            </span>
          </div>
        )}

      <hr className="sol-divider-II" />

      <div className="sol-grid">

        {quotas.map((q) => (

          <div
            key={q._id}
            className="sol-card-credit"
          >

            <div className="sol-linea">
              {q.lineaCredito}
            </div>

            <div className="sol-money">

              $

              {q.disponible?.toLocaleString("es-CO")}

            </div>

            <div className="sol-plazo">

              Plazo máximo:

              {" "}

              {getPlazo(q)}

              {getPlazo(q) === 1
                ? " mes"
                : " meses"}

            </div>

            <button
              className={`sol-btn-request ${q.disponible < 50000
                ? "disabled"
                : ""
                }`}
              disabled={q.disponible < 50000}
              onClick={() => solicitar(q)}
            >
              {q.disponible < 50000
                ? "Sin cupo"
                : "Solicitar"}
            </button>

          </div>
        ))}

      </div>

      <hr className="sol-divider-II" />

      <h3>
        Historial de solicitudes
      </h3>

      <p className="sol-history-text">
        Consulta el historial de tus solicitudes 
        y realiza seguimiento al estado de cada 
        crédito en tiempo real.
      </p>

      <hr className="sol-divider-II" />

      <div className="sol-history">

        {visibleHistory.map((h) => (
          <div
            key={h._id}
            className="sol-history-card"
          >
            <div>

              <span
                className={`sol-status ${h.estado
                  .replace(/\s/g, "")}`}
              >
                Estado: {" "}
                {h.estado}

              </span>

            </div>

            <b>
              {h.lineaCredito}
            </b>

            <div>
              Fecha: {" "}
              {
                new Date(
                  h.createdAt
                ).toLocaleDateString(
                  "es-CO"
                )
              }

            </div>

            <div>

              Valor:

              $

              {h.valorSolicitado?.toLocaleString("es-CO")}

            </div>

            <div>
              Plazo:{" "}
              {h.plazoMeses}{" "}
              {h.plazoMeses === 1 ? "mes" : "meses"}
            </div>

            <hr className="sol-divider-III" />


            {
              h.estado === "Rechazada" &&
              h.motivoRechazo && (

                <div>

                  Motivo de rechazo: {" "}

                  {h.motivoRechazo}

                </div>

              )}

            {h.valorAprobado > 0 && (

              <div>

                Valor aprobado:

                $

                {h.valorAprobado?.toLocaleString("es-CO")}

              </div>

            )}

            {h.plazoAprobado > 0 && (

              <div>

                Plazo aprobado:{" "}

                {h.plazoAprobado}{" "}
                {h.plazoAprobado === 1 ? "mes" : "meses"}

              </div>

            )}

          </div>

        ))}

        {history.length > 2 && (

          <div className="sol-more">

            <button
              onClick={() =>
                setShowAllHistory(
                  !showAllHistory
                )
              }
            >

              {showAllHistory
                ? "Ver menos movimientos"
                : "Ver más movimientos"}

            </button>

          </div>

        )}

      </div>


      {showRequestModal &&
        selectedQuota && (

          <div className="sol-modal-overlay">

            <div className="sol-modal">

              <h3>
                Solicitud de Crédito
              </h3>

              <div className="sol-info">

                <label>
                  Línea de crédito
                </label>

                <div className="sol-readonly">

                  {selectedQuota.lineaCredito}

                </div>

                <label>
                  Cupo disponible
                </label>

                <div className="sol-readonly">

                  $
                  {selectedQuota.disponible
                    ?.toLocaleString("es-CO")}

                </div>

                <label>
                  Plazo máximo
                </label>

                <div className="sol-readonly">
                  {getPlazo(selectedQuota)}{" "}
                  {Number(getPlazo(selectedQuota)) === 1 ? "mes" : "meses"}
                </div>

                <label>
                  Valor solicitado
                </label>

                <input
                  type="number"
                  min={50000}
                  max={
                    selectedQuota.disponible
                  }
                  step={10000}
                  value={requestValue}
                  onChange={(event) =>
                    setRequestValue(
                      event.target.value
                    )
                  }
                />

                <label>
                  Plazo solicitado
                </label>

                {getPlazo(selectedQuota) === 1 ? (

                  <div className="sol-readonly">
                    1 mes
                  </div>

                ) : (

                  <select
                    value={requestPlazo}
                    onChange={(e) =>
                      setRequestPlazo(e.target.value)
                    }
                  >

                    <option value="">
                      Seleccione plazo
                    </option>

                    {Array.from(
                      {
                        length: getPlazo(selectedQuota)
                      },
                      (_, i) => i + 1
                    ).map((mes) => (

                      <option
                        key={mes}
                        value={mes}
                      >
                        {mes} {mes === 1 ? "mes" : "meses"}
                      </option>

                    ))}

                  </select>

                )}

              </div>

              <div className="sol-alert">

                Las solicitudes ingresadas
                antes de las 09:00 a. m. (COT)
                serán desembolsadas el mismo día
                hábil después de las 05:00 p. m. (COT).
                Las solicitudes ingresadas después de las
                09:00 a. m. (COT) serán desembolsadas el
                siguiente día hábil después de las 05:00 p. m.
                (COT), previa aprobación.

              </div>

              <div className="sol-modal-actions">

                <button
                  className="sol-btn-cancel"
                  onClick={() =>
                    setShowRequestModal(false)
                  }
                >
                  Cancelar
                </button>

                <button
                  className="sol-btn-send"
                  disabled={
                    sendingRequest
                  }
                  onClick={
                    enviarSolicitud
                  }
                >
                  {
                    sendingRequest
                      ? "Enviando..."
                      : "Enviar solicitud"
                  }
                </button>

              </div>

            </div>

          </div>

        )}

    </div>

    </>

  );
}